"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const ui_1 = require("@completeanatomy/ui");
const atoms_1 = require("../../atoms");
const lodash_clamp_1 = __importDefault(require("lodash.clamp"));
const lodash_noop_1 = __importDefault(require("lodash.noop"));
const MIN_SWIPE_RANGE = 30;
const GUIDE_START_X = 20;
const GUIDE_END_X = 270;
const WAVE_LENGTH = 250;
function Slider({ className, onHideHint, value: sliderValue = 0, ecgMode, isPlaying = false, bpm = 60, onSwipe = lodash_noop_1.default, }) {
    const startPos = (0, react_1.useRef)(0);
    const endPos = (0, react_1.useRef)(0);
    const bridge = (0, bridge_1.useBridge)();
    const [guidePos, setGuidePos] = (0, react_1.useState)((sliderValue * WAVE_LENGTH) / 100 + 20);
    const [dragging, setDragging] = (0, react_1.useState)(false);
    const fillAnimation = (0, react_1.useRef)(null);
    const handleGuideMove = (xDelta) => {
        setGuidePos(prevGuidePosition => {
            var _a;
            const newValue = (0, lodash_clamp_1.default)(prevGuidePosition + xDelta, GUIDE_START_X, GUIDE_END_X);
            const newSliderValue = ((newValue - GUIDE_START_X) / WAVE_LENGTH) * 100;
            const prevSliderValue = sliderValue;
            (_a = fillAnimation.current) === null || _a === void 0 ? void 0 : _a.setOffset(newSliderValue);
            if (newSliderValue !== prevSliderValue) {
                bridge === null || bridge === void 0 ? void 0 : bridge.beatingHeartSliderValueChangeAction({
                    value: newSliderValue,
                });
            }
            return newValue;
        });
    };
    const handleDrag = (0, react_1.useCallback)((_, phase, data) => {
        // vertical swipe
        if (phase === ui_1.ActionPhase.Start) {
            startPos.current = data.position.y;
            bridge === null || bridge === void 0 ? void 0 : bridge.beatingHeartPauseAction();
            setDragging(true);
        }
        if (phase === ui_1.ActionPhase.End) {
            endPos.current = data.position.y;
            onHideHint();
            setDragging(false);
        }
        const posDelta = startPos.current - endPos.current;
        const isSwipeUp = posDelta > 0;
        if (startPos.current &&
            endPos.current &&
            Math.abs(posDelta) > MIN_SWIPE_RANGE) {
            onSwipe(isSwipeUp);
            startPos.current = 0;
            endPos.current = 0;
        }
        // horizontal swipe
        handleGuideMove(data.positionDelta.x);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ecgMode]);
    const [swipeHandlers] = (0, ui_1.useDragHandlers)(handleDrag, {
        friction: 0.92,
        captureEndOnClick: true,
        captureStartOnClick: true,
    });
    return ((0, jsx_runtime_1.jsx)(SliderContainer, Object.assign({ className: className }, swipeHandlers, { "$ecgMode": ecgMode, role: "slider", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": sliderValue, "data-e2e": 'Slider_SliderContainer', children: (0, jsx_runtime_1.jsxs)("svg", { id: "slider-svg", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 290 150", width: "300", height: "150", "data-e2e": 'Slider_svg', children: [(0, jsx_runtime_1.jsx)(atoms_1.SliderFillAnimation, { isPlaying: isPlaying, bpm: bpm, ref: fillAnimation, "data-e2e": 'Slider_SliderFillAnimation' }), (0, jsx_runtime_1.jsx)(atoms_1.SliderGuide, { position: guidePos, isDragging: dragging, isEcgMode: ecgMode, "data-e2e": 'Slider_SliderGuide' }), (0, jsx_runtime_1.jsx)(atoms_1.SliderPath, { ecgMode: ecgMode, "data-e2e": 'Slider_SliderPath' })] }) })));
}
exports.Slider = Slider;
const SliderContainer = styled_components_1.default.div `
  ${({ $ecgMode }) => !$ecgMode && `transform: translate(-42px,94px) scale(0.65);`};

  transition: transform 0.5s;

  #slider-svg {
    transform: translate(-20px, 0);
  }
`;
